export const tickets = {
  name: "Tickets |||| Tickets",
  tabs: {
    all: "All",
    mine: "Mine",
    unassigned: "Unassigned",
    openTickets: "Open Tickets",
    open: { title: "Open" },
    closed: { title: "Resolved" },
    search: { title: "Search" },
  },
  buttons: {
    spy: "Spy",
    newTicket: "+ New Ticket",
    showAll: "Show All",
    accept: "Accept",
    preview: "Preview",
  },
  sort: {
    label: "Sort by",
    lastActivity: "Last activity",
    createdDate: "Created date",
    priority: "Priority",
  },
  contextMenu: {
    changeStatus: "Change status",
    changePriority: "Change priority",
    assignToMe: "Assign to me",
    unassign: "Unassign",
    assignTo: "Assign to...",
    transfer: "Transfer...",
    copyLink: "Copy link",
    openNewTab: "Open in new tab",
    linkCopied: "Link copied!",
  },
  search: {
    placeholder: "Search tickets...",
  },
  queueSelect: {
    placeholder: "Queues",
    allQueues: "All",
  },
  unknownContact: "Unknown Contact",
  noQueue: "No queue",
  status: {
    closed: "resolved",
  },
  sections: {
    pending: "Pending",
    inProgress: "In progress",
  },
  filters: {
    search: "Search conversations...",
    status: "Status",
    priority: "Priority",
    queue: "Queue",
    channel: "Channel",
    advancedFilters: "Advanced Filters",
    activeFilters: "active filter |||| active filters",
    clearAll: "Clear filters",
  },
  actions: {
    createConversation: "New Conversation",
    createTicket: "Create Ticket",
    assignTicket: "Assign",
    transferTicket: "Transfer",
    closeTicket: "Resolve Ticket",
    resolveTicket: "Resolve",
    reopenTicket: "Reopen",
    markAsRead: "Mark as read",
    toggleDetails: "Toggle details",
  },
  details: {
    title: "Details",
    contactInfo: "Contact Information",
    userInfo: "User Information",
    ticketInfo: "Ticket Information",
    noTicket: "No active ticket",
    quickActions: "Quick Actions",
    actionsComingSoon: "Quick actions coming soon...",
  },
  empty: {
    title: "No conversation selected",
    subtitle: "Select a conversation from the list to start",
    noConversations: "No conversations found",
    noConversationsSubtitle:
      "Adjust filters or create a new conversation",
  },
  typing: "%{name} is typing...",
  unread: "%{count} unread |||| %{count} unread",
  list: {
    assignedHeader: "Assigned",
    pendingHeader: "Pending",
    closedHeader: "Resolved",
    allHeader: "All Tickets",
    noTicketsTitle: "No tickets found",
    noTicketsMessage: "All tickets have been handled or no tickets match your filters.",
  },
  settings: {
    title: "Ticket Settings",
    error: {
      load: "Failed to load settings",
      save: "Failed to save settings",
    },
    success: {
      saved: "Settings saved successfully",
    },
    autoReopen: {
      title: "Auto-Reopen Time",
      description: "When a customer sends a message to a closed ticket within this time window, the ticket will be reopened instead of creating a new one. Set to 0 to always create new tickets.",
      disabled: "Disabled (always create new ticket)",
      minutes: "%{minutes} minutes",
      hours: "%{hours} hour(s)",
      hoursAndMinutes: "%{hours}h %{minutes}m",
      unit: "min",
      hint: {
        disabled: "New messages from customers will always create a new ticket.",
        enabled: "Closed tickets will be reopened if a customer sends a message within %{time}.",
      },
    },
  },
};

export const ticket = {
  name: "Ticket |||| Tickets",
  fields: {
    id: "Ticket ID",
    subject: "Subject",
    status: "Status",
    priority: "Priority",
    assignedTo: "Assigned to",
    assignedUserId: "Assigned to",
    assignedUser: "Assignee",
    assignee: "Assignee",
    queue: "Queue",
    queueId: "Queue",
    ticketQueue: "Queue",
    conversation: "Conversation",
    conversationId: "Conversation",
    resolvedAt: "Resolved at",
    closedAt: "Resolved at",
    firstResponseAt: "First response at",
    tags: "Tags",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
  status: {
    PENDING: "Pending",
    OPEN: "Open",
    IN_PROGRESS: "In Progress",
    WAITING_CUSTOMER: "Waiting Customer",
    WAITING_THIRD_PARTY: "Waiting Third Party",
    RESOLVED: "Resolved",
    CLOSED: "Resolved",
    pending: "Pending",
    open: "Open",
    in_progress: "In Progress",
    waiting_customer: "Waiting Customer",
    waiting_third_party: "Waiting Third Party",
    resolved: "Resolved",
    closed: "Resolved",
  },
  statusDescription: {
    pending: "Ticket is pending, awaiting assignment",
    open: "Ticket is open and awaiting attention",
    resolved: "Ticket resolved, awaiting closure",
    closed: "Ticket is resolved and finalized",
  },
  search: {
    placeholder: "Search tickets...",
  },
  queue: {
    none: "No queue",
    default: "Default queue",
    noQueues: "No queues available",
  },
  priority: {
    label: "Priority",
    none: "No priority",
    noneDescription: "No priority set",
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
    URGENT: "Urgent",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
  },
  priorityDescription: {
    low: "Can be resolved within 72 hours",
    medium: "Should be resolved within 24 hours",
    high: "Requires immediate attention, resolve within 4 hours",
    urgent: "Critical! Resolve as soon as possible",
  },
  tabs: {
    chat: "Chat",
    details: "Details",
  },
  details: {
    title: "Ticket Details",
    id: "Ticket ID",
    priority: "Priority",
    status: "Status",
    created: "Created",
    updated: "Updated",
    assignment: "Assignment",
    unassigned: "This ticket is unassigned",
    assignedTo: "Assigned to",
    queue: "Queue",
    noQueue: "No queue",
    contact: "Contact",
    noContact: "No contact information",
    conversation: "Conversation",
    timeline: "Timeline",
    firstResponse: "First response",
    resolvedAt: "Resolved at",
    closedAt: "Resolved at",
  },
  actions: {
    assign: "Assign",
    assignToMe: "Assign to me",
    unassign: "Unassign",
    changeStatus: "Change status",
    changePriority: "Change priority",
    close: "Resolve ticket",
    reopen: "Reopen ticket",
    resolve: "Resolve ticket",
    viewConversation: "View conversation",
    returnToPending: "Return to Pending",
    transfer: "Transfer",
  },
  empty: {
    title: "No tickets",
    subtitle: "There are no tickets to display yet.",
  },
  filters: {
    status: "Status",
    priority: "Priority",
    assignedTo: "Assigned to",
    queue: "Queue",
    unassigned: "Unassigned",
  },
  noTicket: "No ticket",
  viewDetails: "View ticket details",
  unassigned: "Unassigned",
  noQueue: "No queue",
  timestamps: "Timestamps",
  assignee: "Assignee",
  createdAt: "Created at",
  statusSelect: {
    current: "Current",
    confirmTitle: "Confirm Status Change",
    confirmCloseMessage:
      "Are you sure you want to resolve this ticket? This action cannot be easily undone.",
    confirmClose: "Resolve Ticket",
  },
  assigneeSelect: {
    placeholder: "Search users...",
    noUsers: "No users found",
    unassign: "Unassign",
    open: "Show users",
    close: "Close",
  },
  notifications: {
    existingTicketOpened:
      "An open ticket already exists for this contact. Redirecting...",
    closed: "Ticket resolved successfully",
    closeFailed: "Failed to resolve ticket",
    reopened: "Ticket reopened successfully",
    reopenFailed: "Failed to reopen ticket",
    reopenBlockedByActiveTicket:
      "Cannot reopen: contact already has an active ticket (#%{ticketId})",
    returnedToPending: "Ticket returned to pending",
    returnFailed: "Failed to return ticket",
    transferred: "Ticket transferred successfully",
    transferFailed: "Failed to transfer ticket",
    spyMode: "Spy mode view activated",
    spyFailed: "Failed to activate spy mode",
    fetchFailed: "Failed to fetch tickets",
  },
  dialogs: {
    edit: {
      helperText: {
        assignedUser: "Reassign to a different team member",
      },
    },
    transfer: {
      title: "Transfer Ticket",
      type: "Transfer Type",
      toUser: "To User",
      toQueue: "To Queue",
      selectUser: "Select User",
      selectQueue: "Select Queue",
    },
  },
};
